import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styles from "./Survey.scss";
import Questions from "./Questions";
import { postSurveyData } from "../../../actions/Map/submitAction";
import Loader from "../../Loader/Loader";
import classnames from "classnames";
import { setTogglesExternal } from "../../../actions/Map/surveyActions";
import {
	updateVisitor,
	setUserInfo
} from "../../../actions/DataCol/userdataAction";

class Survey extends Component {
	constructor(props) {
		super(props);
		this.state = {
			question: 0,
			loading: false,
			lastQuestion: 4,
			multi_answer: [0, 1, 2],
			answers: {
				0: [-1, -1, -1, -1],
				1: [-1, -1, -1, -1],
				2: [-1, -1, -1],
				3: -1,
				4: -1
			},
			results: undefined,
			optionHover: false
		};
	}

	setResults = array => {
		this.setState({ results: array }, () => {
			var user = this.props.user;
			if (user && user.survey) {
				user["survey"]["results"] = this.state.results;
				user["survey"]["answers"] = this.state.answers;
				updateVisitor(user);

				this.props.setUserInfo(user);
			}
		});
	};

	componentWillUnmount() {
		this.setState({ loading: false });
		// Check if we need to toggle anythin for the map
		let externalToggles = [];
		if (this.state.answers[0].includes(0)) {
			externalToggles = [...externalToggles, "transit"];
		}
		if (this.state.answers[1].includes(2)) {
			externalToggles = [...externalToggles, "dogparks"];
		}
		if (this.state.answers[2].includes(0)) {
			externalToggles = [...externalToggles, "Hospitals"];
		}
		if (this.state.answers[2].includes(1)) {
			externalToggles = [...externalToggles, "childcare"];
		}
		if (this.state.answers[2].includes(2)) {
			externalToggles = [...externalToggles, "Long-Term Care"];
		}

		this.props.setTogglesExternal(externalToggles);
	}

	back = () => {
		let num = this.state.question - 1;
		if (num <= 0) {
			this.setState({ question: 0 });
		} else {
			this.setState({ question: num });
		}
	};

	skip = () => {
		let num = this.state.question + 1;
		if (num > this.state.lastQuestion) {
			postSurveyData(this.state.answers, this.setResults);
			this.setState({ loading: true });
		} else {
			this.setState({ question: num });
		}
	};

	next = i => {
		let answers = undefined;
		// If question has multiple possible answers
		if (this.state.multi_answer.includes(this.state.question)) {
			answers = { ...this.state.answers };
			// Allow for Toggle On and Off of Answers
			if (answers[this.state.question][i] === -1) {
				answers[this.state.question][i] = i;
			} else {
				answers[this.state.question][i] = -1;
			}
			// Save responses
			this.setState({ answers: answers });
		}
		// If question only has one answer
		else {
			answers = { ...this.state.answers };
			answers[this.state.question] = i;
			// If already selected, unselect
			if (this.state.answers[this.state.question] === i) {
				answers[this.state.question] = -1;
				this.setState({ answers: answers });
			} else {
				// Increment question counter
				this.setState({
					answers: answers
				});
			}
		}
	};

	render() {
		let question;
		question = (
			<div className="card-deck">
				{Questions[this.state.question].options.map((option, index) => (
					<div
						className={classnames("card", styles.card, {
							[styles.selected]: Array.isArray(
								this.state.answers[this.state.question]
							)
								? this.state.answers[
										this.state.question
								  ].includes(index)
								: this.state.answers[this.state.question] ===
								  index
						})}
						onClick={this.next.bind(null, index)}
						key={index}
					>
						<h5
							className={classnames(
								"card-title",
								styles.questionTitle
							)}
						>
							{option.option.toUpperCase()}
						</h5>
						<img
							className={styles.questionImage}
							src={
								option.image
									? require(`./images/${option.image}`)
									: require(`./images/RS10960_180508_111455_KAP_0089.jpg`)
							}
							alt=""
						/>
						<div
							className={classnames("card-body", styles.cardBody)}
						>
							<div className="card-text">
								{option.summary && (
									<h5 className={styles.summary}>
										{option.summary}
									</h5>
								)}
								{option.desc && (
									<h6 className={styles.desc}>
										{option.desc}
									</h6>
								)}
							</div>
						</div>
					</div>
				))}
			</div>
		);

		return (
			<div className={classnames(styles.container)}>
				{!this.state.loading && (
					<div>
						<ul className="nav justify-content-center">
							{[
								"Commute",
								"Amenities",
								"Services",
								"Home",
								"Backyard"
							].map((q, i) => (
								<li
									className={classnames(
										"nav-item",
										styles.navItems,
										{
											[styles.navItemSelected]:
												i <= this.state.question
										}
									)}
									onClick={() =>
										this.setState({ question: i })
									}
									key={i}
								>
									<h6 className="nav-link active" href="#">
										{q}
									</h6>
								</li>
							))}
						</ul>
						<div className="progress">
							<div
								className={classnames(
									"progress-bar",
									styles.progressBar
								)}
								style={{
									width:
										((this.state.question + 1) / 5) * 100 +
										"%"
								}}
							/>
						</div>
						<br />

						<div className="col-xs-12" align="center">
							<h3>
								<button
									type="button"
									className={classnames(
										"btn btn-outline-secondary",
										styles.buttonLeft,
										styles.hide
									)}
									onClick={this.back}
								>
									Previous
								</button>
								{Questions[this.state.question]["question"]}
								<button
									type="button"
									className={classnames(
										"btn btn-outline-secondary",
										styles.buttonRight
									)}
									onClick={this.skip}
								>
									{this.state.answers[this.state.question] ===
										-1 ||
									(this.state.multi_answer.includes(
										this.state.question
									) &&
										this.state.answers[
											this.state.question
										].every((val, i, arr) => val === -1))
										? "Skip"
										: "Next"}
								</button>
							</h3>
						</div>

						{question}
						<div
							className={classnames("mx-auto", styles.buttonBox)}
						>
							<button
								type="button"
								className={classnames(
									"btn btn-outline-secondary",
									styles.buttonLeft
								)}
								onClick={this.back}
							>
								Previous
							</button>
							<button
								type="button"
								className={classnames(
									"btn btn-outline-secondary",
									styles.buttonRight
								)}
								onClick={this.skip}
							>
								{this.state.answers[this.state.question] ===
									-1 ||
								(this.state.multi_answer.includes(
									this.state.question
								) &&
									this.state.answers[
										this.state.question
									].every((val, i, arr) => val === -1))
									? "Skip"
									: "Next"}
							</button>
						</div>
					</div>
				)}
				{this.state.loading && (
					<div>
						<Loader />
					</div>
				)}
				{this.state.results && (
					<div>
						return{" "}
						<Redirect
							to={`/neighbourhoods/?results=${this.state.results.join()}`}
						/>
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		user: state.user.user
	};
}

const actions = {
	setTogglesExternal,
	setUserInfo
};

export default connect(
	mapStateToProps,
	actions
)(Survey);



// WEBPACK FOOTER //
// ./src/components/pages/Survey/Survey.js